import http from '../services/http';
import { typeAs } from '../services/utils';
import Str from '../services/str';

export default {
  namespaced: true,

  state: {
    members: [],
    member: null,
    links: null,
    meta: null,
    filter: {
      keyword: null,
      createdAtRange: [],
      country: null,
      isSubscription: null,
      age: null,
      month: null,
    },
    countryOptions: null,
    monthOptions: [
      { value: 1, title: '1月' },
      { value: 2, title: '2月' },
      { value: 3, title: '3月' },
      { value: 4, title: '4月' },
      { value: 5, title: '5月' },
      { value: 6, title: '6月' },
      { value: 7, title: '7月' },
      { value: 8, title: '8月' },
      { value: 9, title: '9月' },
      { value: 10, title: '10月' },
      { value: 11, title: '11月' },
      { value: 12, title: '12月' },
    ],
    ageOptions: [
      { value: 0, title: '1-15' },
      { value: 1, title: '16-20' },
      { value: 2, title: '21-25' },
      { value: 3, title: '26-30' },
      { value: 4, title: '31-35' },
      { value: 5, title: '36-40' },
      { value: 6, title: '41-45' },
      { value: 7, title: '46-50' },
      { value: 8, title: '51-55' },
      { value: 9, title: '56-60' },
      { value: 10, title: '61-65' },
      { value: 11, title: '65-' },
    ],
  },

  mutations: {
    CLEAR_ALL(state) {
      state.members = [];
      state.member = null;
    },
    SET_MEMBERS(state, data) {
      state.members = data.data.map(
        (item) => {
          item.isChecked = false;
          return item;
        },
      );
      state.links = data.links;
      state.meta = data.meta;
    },
    SET_MEMBER(state, data) {
      state.member = data;
    },
    SET_FILTER(state, data) {
      state.filter = data;
    },
    SET_COUNTRY_OPTIONS(state, data) {
      state.countryOptions = data;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },

    setFilter({ commit }, data) {
      commit('SET_FILTER', data);
    },

    find({ commit, state }) {
      let url = `/members?${Str.query(state.filter)}`;
      if (state.meta) {
        url += `&page=${state.meta.current_page}&page_count=${state.meta.per_page}`;
      }
      return http(url)
        .then((response) => {
          response.body.data.map(typeAs('Member'));
          return response.body;
        })
        .then((response) => {
          commit('SET_MEMBERS', response);
          return response;
        });
    },

    findById({ commit }, id) {
      return http(`/members/${id}`)
        .then((response) => response.body)
        .then(typeAs('Member'))
        .then((item) => {
          commit('SET_MEMBER', item);
          return item;
        });
    },

    toggleSubscribe({ commit }, id) {
      return http(`/members/${id}/subscribe`, { method: 'PUT' })
        .then((response) => response.body)
        .then(typeAs('Member'))
        .then((item) => {
          commit('SET_MEMBER', item);
        });
    },

    getMemberCountries({ commit, state }) {
      if (state.countryOptions === null) {
        return http('/member/countries')
          .then((response) => response.body)
          .then((response) => {
            commit('SET_COUNTRY_OPTIONS', response);
            return response;
          });
      }
    },

    sendResetPasswordEmail(_, id) {
      return http(`/members/${id}/password_forgot`, { method: 'POST' })
        .then((response) => response.body);
    },
  },
};
